import currencyData from '@assets/data/currency.json';

export class CurrencyUtils {
  static getCurrencyByCode = (code: string) => currencyData.find((currency) => currency.code.toLowerCase() === code.toLowerCase());

  static getSymbolByCode = (code?: string) => {
    if (!code) return '';
    return this.getCurrencyByCode(code)?.symbol ?? '';
  };
}
